import React, { Fragment, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import validator from 'validator';

import { IMaskInput } from 'react-imask';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Box from '@mui/material/Box';
import { makeStyles } from '@mui/styles';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Checkbox from '@mui/material/Checkbox';
import PersonIcon from '@mui/icons-material/Person';
import AccountCircle from '@mui/icons-material/AccountCircle';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';

import { setDataAction  } from 'redux/actions/getFormActions';

const useStyles = makeStyles((theme) => ({
    select: {
        '& .MuiSvgIcon-root': {
            color: theme.palette.primary.main
        },
        '&:hover': {
            backgroundColor: '#e4dfdf6b'
        }
    },
    icon: {
        fill: theme.palette.primary,
    },
}));

const TextMaskCustom = React.forwardRef(function TextMaskCustom(props, ref) {
  const { onChange, ...other } = props;
  return (
    <IMaskInput
      {...other}
      mask="(+44) 000 000 0000"
      definitions={{
        '#': /[1-9]/,
      }}
      inputRef={ref}
      onAccept={(value) => onChange({ target: { name: props.name, value } })}
      overwrite
    />
  );
});

TextMaskCustom.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

const Form4 = (props) => {
    const {actions, token, formData, handleNext, handleBack } = props;
    const classes = useStyles();

    const [data, setFormData] = useState({
      name: null,
      phone: null,
      email: null,
      title: null,
      check: false,
    });

    const [valid, setValid] = useState({
      name: false,
      phone: false,
      email: false,
      title: false
    })

    const [disabled, setDisable] = useState(true);
    
    useEffect(() => {
      setFormData({
        name:  formData.data.contactName,
        phone: formData.data.contactPhone,
        email: formData.data.contactEmail,
        title: formData.data.contactTitle,
        check: formData.data.contactPhone ? true : false,
      });
      if(formData.data.contactPhone) {
        setValid({
          name: true,
          phone: true,
          email: true,
          title: true
        })
      }
    }, [formData])

    const handleChange = (e, label) => {

      const value = e.target.value;
      if(label === 'check') {
        setFormData({...data, [label]:e.target.checked});
      } else {
        setFormData({...data, [label]:value});
      }
      if(label === 'email') {
        console.log(validator.isEmail(value))
        setValid({...valid, email: validator.isEmail(value)});
      } else if (label === 'phone') {
        setValid({...valid, phone: (value.length === 18 ? true : false) });
      } else {
        setValid({...valid, [label]: true});
      }
    };
    console.log(valid)
    const handleNextButton = () => {
        actions.setDataAction({
            ...formData.data,
            contactName: data.name,
            contactEmail: data.email,
            contactPhone: data.phone,
            contactTitle: data.title,
        })
        handleNext();
    }
  return (
    <Fragment>
      {/* <Typography variant="h6" gutterBottom color="primary" sx={{mt: 5}}>
        Locate Your Apartment Complex
      </Typography> */}
          <Grid container justifyContent='center' sx={{ my: 1, mt: 3 }}>
              <Grid item xs={10}>
                <Grid container justifyContent="center" alignItems="center">
                  <Grid item xs={2} sx={{p: 1, mt: 2}}>
                    <AccountCircle sx={{fontSize: 40 }} color="primary"/>
                  </Grid>
                  <Grid item xs={10}>
                    <Typography variant="body2" color="primary">Contact Name</Typography>
                    <TextField
                        // error={!data.name}
                        // label="Contact Name"
                        variant="standard"
                        color={data.name ? "primary" : "error"}
                        required
                        autoFocus
                        fullWidth
                        value={data.name}
                        onChange={(e) => handleChange(e, 'name')} 
                        // helperText={!data.name && "Required" }
                        />
                  </Grid>
                </Grid>
              </Grid>
          </Grid>
          <Grid container justifyContent='center' sx={{ my: 1 }}>
              <Grid item xs={10}>
                <Grid container justifyContent="center" alignItems="center">
                  <Grid item xs={2} sx={{p: 1}}>
                    <AccountCircle sx={{fontSize: 40 }} color="primary"/>
                  </Grid>
                  <Grid item xs={10}>
                      <Typography variant="body2" color="primary">Contact Title</Typography>
                      <TextField
                          // error={!data.title}
                          // label="Contact Title"
                          variant="standard"
                          color={data.title ? "primary" : "error"}
                          required
                          // autoFocus
                          fullWidth
                          value={data.title}
                          onChange={(e) => handleChange(e, 'title')} 
                          // helperText={!data.title && "Required" }
                      />
                  </Grid>
                </Grid>
              </Grid>
          </Grid>
          <Grid container justifyContent='center' sx={{ my: 1 }}>
              <Grid item xs={10}>
                <Grid container justifyContent="center" alignItems="center">
                  <Grid item xs={2} sx={{p: 1}}>
                    <EmailIcon sx={{fontSize: 40 }} color="primary"/>
                  </Grid>
                  <Grid item xs={10}>
                      <Typography variant="body2" color="primary">Contact Email</Typography>
                      <TextField
                          error = {!valid.email && data.email}
                          // label="Contact Email"
                          variant="standard"
                          color={data.email ? "primary" : "error"}
                          required
                          // autoFocus
                          fullWidth
                          value={data.email}
                          onChange={(e) => handleChange(e, 'email')} 
                          helperText={(!valid.email && data.email) ? "Invalid Input" : ""}
                      />
                  </Grid>
                </Grid>
              </Grid>
          </Grid>
          <Grid container justifyContent='center' sx={{ my: 1 }}>
          <Grid item xs={10}>
                <Grid container justifyContent="center" alignItems="center">
                  <Grid item xs={2} sx={{p: 1, mt: 2}}>
                    <PhoneIcon sx={{fontSize: 40 }} color="primary"/>
                  </Grid>
                  <Grid item xs={10}>
                      <Typography variant="body2" color="primary">Contact Phone Number</Typography>
                      <TextField
                          error={!valid.phone && data.phone}
                          // label="Contact Phone Number"
                          variant="standard"
                          color={data.phone ? "primary" : "error"}
                          required
                          // autoFocus
                          fullWidth
                          value={data.phone}
                          onChange={(e) => handleChange(e, 'phone')}
                          helperText={(!valid.phone && data.phone) && 'Invalid Input'}
                          InputProps={{
                            inputComponent: TextMaskCustom
                          }}
                      />
                  </Grid>
                </Grid>
              </Grid>
          </Grid>
          <Grid container justifyContent='center' sx={{ mt: 5}} wrap="nowrap" alignItems="center">
                <Checkbox 
                  checked={data.check}
                  onChange={(e) => handleChange(e, 'check')}
                />
            <Typography color="primary" variant="body1" align="center">     
                By checking this box, I acknowledge that the information <br/>
                I have entered in this form is true to the best of my knowledge.
            </Typography>
        
        </Grid>
        <Box sx={{ display: 'flex', justifyContent: 'center', flexDirection: 'row', py: 2 }}>
                <Button
                  onClick={handleBack}
                  sx={{ mr: 1 }}
                  variant="contained"
                >
                Back
                </Button>

            <Button 
              onClick={handleNextButton} 
              variant="contained" 
              disabled={!(data.name && data.title && data.phone && data.email && data.check && valid.name  && valid.title && valid.phone && valid.email)}
            >
                <Typography variant='body1' >
                    Next
                </Typography>
            </Button>
        </Box>
    </Fragment>
  );
}

const mapStateToProps = (state) => {
    return {
        formData: state.formData
    };
  };
  
  const mapDispatchToProps = (dispatch) => {
    return {
      actions: bindActionCreators({ 
            setDataAction, 
        }, dispatch),
    };
  };
  
export default connect(mapStateToProps, mapDispatchToProps)(Form4);
